import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

interface ComingSoonPageProps {
  title: string;
  description: string;
  icon?: string;
  backHref?: string;
  backLabel?: string;
}

export default function ComingSoonPage({
  title,
  description,
  icon = 'ri-time-line',
  backHref = '/',
  backLabel = '返回首页',
}: ComingSoonPageProps) {
  return (
    <div className="min-h-screen bg-white font-body flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-24">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100 mx-auto mb-6">
            <i className={`${icon} text-3xl text-primary-600`}></i>
          </div>
          <h1 className="font-heading font-bold text-2xl text-foreground-950 mb-3">{title}</h1>
          <p className="text-foreground-500 text-sm leading-relaxed mb-8">{description}</p>
          <Link
            to={backHref}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl bg-primary-500 text-foreground-950 font-semibold text-sm hover:bg-primary-400 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            {backLabel}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}